import { CampaignErrorHandleField } from 'components/campaign/campaignCreation/CreateCampaignHandleError';
import { StampCampaignErrorHandleField } from 'components/stampCampaign/stampCampaignCreation/CreateStampCampaignHandleError';
import { CampaignType, EarningRuleRewardType, LanguageConfig, STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY, TARGET_CUSTOMER_TYPE } from 'config/CustomEnums';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';
import { validateRecurringPeriod } from 'containers/engagement/campaign/RecurringDateValidate'
import { recurringMessageValidate } from './RecurringMessageValidate';

import { checkIsPositiveInteger } from 'utils';
import { TimeFormater, formatDate } from 'utils/TimeFormatUtil';
import { IMAGE_TYPES } from 'models/UploadFilesModel';


function firstStepValidate({ getValues, setError }) {
  return true;
}

function checkRequiredStampRepeat(reward, rewardList) {
  let repeat = 0;
  rewardList.forEach((item, index) => {
    if (Number(item.requiredStamps) === Number(reward.requiredStamps)) {
      repeat += 1;
    }
  });
  return repeat !== 1;
}

export const validateStampRewards = ({ getValues, prefix = "", }) => {
  const errorList = []
  const [
    stampRewards,
  ] = getValues([
    `${prefix}stampRewards`,
  ]);
  if (!stampRewards || stampRewards?.length === 0) {
    errorList.push({
      sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
      name: `${prefix}stampRewards`,
      message: StampCampaignErrorHandleField.stampReward.message,
    });

    return errorList
  }
  let quiredStampList = [];
  let couponTypeRewardError = false;
  stampRewards.forEach((item, index) => {
    const rewardError = [];
    if (
      item.rewardType === EarningRuleRewardType.coupons &&
      !item?.linkedCoupon?.name
    ) {
      rewardError.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        name: `${prefix}stampRewards[${index}].linkedCoupon`,
        message: StampCampaignErrorHandleField.linkedCoupon.message,
      });
    }
    if (
      isEmpty(item?.requiredStamps) ||
      Number(item?.requiredStamps) < 0 ||
      Number(item?.requiredStamps) > 9999
    ) {
      rewardError.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        name: `${prefix}stampRewards[${index}].requiredStamps`,
        message: StampCampaignErrorHandleField.numberLimit.message,
      });
    } else if (checkRequiredStampRepeat(item, stampRewards)) {
      rewardError.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        name: `${prefix}stampRewards[${index}].requiredStamps`,
        message: StampCampaignErrorHandleField.requiredStamps.message,
      });
    } else {
      quiredStampList.push(item.requiredStamps);
    }
    if (isEmpty(item?.quantity) || Number(item?.quantity) < 0) {
      rewardError.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        name: `${prefix}stampRewards[${index}].quantity`,
        message: StampCampaignErrorHandleField.quantityRequired.message,
      });
    }
    if (
      item.rewardType === EarningRuleRewardType.coupons &&
      Number(item.quantity) > Number(item?.linkedCoupon?.stock)
    ) {
      rewardError.push({
        sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        name: `${prefix}stampRewards[${index}].quantity`,
        message: StampCampaignErrorHandleField.couponQuantity.message,
      });
    }
    if (rewardError?.length > 0 && item.rewardType === EarningRuleRewardType.coupons) {
      couponTypeRewardError = true
    }
    errorList.push(...rewardError)
  });

  if (errorList?.length > 0) {
    errorList.push({
      sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
      name: `${prefix}stampRewardError`,
      message: 'Error',
    });
  }
  if (couponTypeRewardError) {
    errorList.push({
      sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
      name: `${prefix}couponTypeRewardError`,
      message: 'Error',
    });
  }
  return errorList
}
function stampCampaignSecondStepValidate({ getValues }) {
  const [
    coverPhoto,
    isExclusive,
    square,
    linkedEarningRules,
    stampRewards,
    useUploadStampIcons,
    emptyStampSlot,
    collectedStamp,
    emptyGiftStampSlot,
    collectedGift,
  ] = getValues([
    'translations.en.coverPhoto',
    'isExclusive',
    'translations.en.squareCoverPhoto',
    'linkedEarningRules',
    'stampRewards',
    'useUploadStampIcons',
    'stampCampaignTypeEmptySlotStampImage',
    'stampCampaignTypeAcquiredStampImage',
    'stampCampaignTypeEmptyGiftSlotImage',
    'stampCampaignTypeCollectedGiftImage',
  ]);
  let errorList = [];
  if (!coverPhoto || (coverPhoto && typeof coverPhoto !== 'string' && coverPhoto.type !== IMAGE_TYPES.TYPE_URL)) {
    errorList.push({
      name: 'translations.en.coverPhoto',
      message: StampCampaignErrorHandleField.coverPhoto.message,
    });
  }
  if (isExclusive && (!square || square && typeof square !== 'string' && square.type !== IMAGE_TYPES.TYPE_URL)) {
    errorList.push({
      name: 'translations.en.squareCoverPhoto',
      message: StampCampaignErrorHandleField.squarePhoto.message,
    });
  }
  if (!linkedEarningRules || linkedEarningRules?.length === 0) {
    errorList.push({
      name: 'linkedEarningRules',
      message: StampCampaignErrorHandleField.linkedEarningRules.message,
    });
  }
  if (useUploadStampIcons) {
    if (!emptyStampSlot) {
      errorList.push({
        name: 'stampCampaignTypeEmptySlotStampImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!collectedStamp) {
      errorList.push({
        name: 'stampCampaignTypeAcquiredStampImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!emptyGiftStampSlot) {
      errorList.push({
        name: 'stampCampaignTypeEmptyGiftSlotImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
    if (!collectedGift) {
      errorList.push({
        name: 'stampCampaignTypeCollectedGiftImage',
        message: StampCampaignErrorHandleField.fileRequired.message,
      });
    }
  }
  errorList = [
    ...errorList,
    validateStampRewards({ getValues })
  ]

  let stampRewardHasError = false;
  errorList.forEach((error) => {
    if (error.name.includes('stampReward')) {
      stampRewardHasError = true;
    }
  });

  if (stampRewardHasError) {
    errorList.push({
      name: 'stampRewardHasError',
      message: 'stampRewardHasError',
    });
  }

  return errorList;
}

function secondStepAllLanguagesValidate({
  getValues,
  languages,
  isStampCampaign = false,
}) {
  let errorList = [];
  languages.forEach((language) => {
    const genenralNameField = `translations.${language}.generalName`;
    const [generalName] = getValues([genenralNameField]);
    if (
      (language === LanguageConfig.english && !generalName) ||
      (!!generalName && generalName.length > 200)
    ) {
      errorList.push({
        name: genenralNameField,
        message: isStampCampaign
          ? StampCampaignErrorHandleField.generalName.message
          : CampaignErrorHandleField.generalName.message,
      });
    }
  });
  return errorList;
}

function secondStepValidate({ getValues, setError, languages }) {
  const [
    coverPhoto,
    isExclusive,
    square,
    campaignType,
  ] = getValues([
    'translations.en.coverPhoto',
    'isExclusive',
    'translations.en.squareCoverPhoto',
    'campaignType',
  ]);
  let errorList = [];
  const isStampCampaign = campaignType === CampaignType.stampCampaign;

  const allLanguagesErrorList = secondStepAllLanguagesValidate({
    getValues,
    languages,
    isStampCampaign,
  });
  errorList = [...errorList, ...allLanguagesErrorList];

  if (!isStampCampaign) {
    if (!coverPhoto || coverPhoto.type !== IMAGE_TYPES.TYPE_URL) {
      errorList.push({
        name: 'translations.en.coverPhoto',
        message: CampaignErrorHandleField.coverPhoto.message,
      });
    }
    if (isExclusive && (!square|| square.type !== IMAGE_TYPES.TYPE_URL)) {
      errorList.push({
        name: 'translations.en.squareCoverPhoto',
        message: CampaignErrorHandleField.squarePhoto.message,
      });
    }
  } else {
    const stampCampaignErrorList = stampCampaignSecondStepValidate({
      getValues,
    });
    errorList = [...errorList, ...stampCampaignErrorList];
  }
  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

const isEmpty = (value) => {
  return value === undefined || value === null || value === '' || isNaN(value);
};

function recurringDateValidate({ getValues, errorList }) {
  const [
    isBirthdayRecurringCampaign,
    recurringDate,
  ] = getValues([
    'isBirthdayRecurringCampaign',
    'recurringDate',
  ]);
  if (!isBirthdayRecurringCampaign || !recurringDate) {
    return
  }
  validateRecurringPeriod({ isActive: true, isStart: true, recurringDate, errorList })
  validateRecurringPeriod({ isActive: true, isStart: false, recurringDate, errorList })
  validateRecurringPeriod({ isActive: false, isStart: true, recurringDate, errorList })
  validateRecurringPeriod({ isActive: false, isStart: false, recurringDate, errorList })
}

function thirdStepValidate({ getValues, setError }) {
  const [
    executionPriority,
    isExclusive,
    activeStartDate,
    activeEndDate,
    visibleStartDate,
    visibleEndDate,
    campaignType,
    requiredPoints,
    isAlwaysActivePeriod,
    isAlwaysVisiblePeriod,
    dynamicSegments,
    staticSegments,
    levels,
    excludeBlacklistSegment,
    blacklistSegments,
    generalType,
    perHeadLimit,
    linkedCoupon,
    relatedBannerStartDate,
    relatedBannerEndDate,
    ticketCampaignTimeSlots,
    showCustomerProfileFields,
    showCustomerAdditionalFields,
    additionalQuestion,
    malls,
  ] = getValues([
    'executionPriority',
    'isExclusive',
    'activeStartDate',
    'activeEndDate',
    'visibleStartDate',
    'visibleEndDate',
    'campaignType',
    'requiredPoints',
    'isAlwaysActivePeriod',
    'isAlwaysVisiblePeriod',
    "dynamicSegments",
    "staticSegments",
    "levels",
    "excludeBlacklistSegment",
    "blacklistSegments",
    'generalType',
    'perHeadLimit',
    'linkedCoupon',
    'relatedBannerStartDate',
    'relatedBannerEndDate',
    'ticketCampaignTimeSlots',
    'showCustomerProfileFields',
    'showCustomerAdditionalFields',
    'additionalQuestion',
    'malls',
  ]);
  const errorList = [];
  const isStampCampaign = campaignType === CampaignType.stampCampaign;
  if (isStampCampaign && (!executionPriority || executionPriority < 1)) {
    errorList.push({
      name: 'executionPriority',
      message: "Please provide a valid execution priority",
    });
  }
  if (
    !isAlwaysActivePeriod &&
    activeStartDate.getTime() >= activeEndDate.getTime()
  ) {
    errorList.push({
      name: 'activeEndDate',
      message: CampaignErrorHandleField.activeEndDate.message,
    });
    // errorFields.push(CampaignErrorHandleField.activeEndDate.name);
  }
  if (campaignType === CampaignType.couponsCampaign) {
    const requiredPointsIsValid = checkIsPositiveInteger(requiredPoints);
    if (!requiredPointsIsValid) {
      errorList.push({
        name: 'requiredPoints',
        message: CampaignErrorHandleField.requiredPoints.message,
      });
    }
    if (
      Number(perHeadLimit) >
      Number(linkedCoupon?.totalNumberOfGeneratedCoupons)
    ) {
      errorList.push({
        name: 'perHeadLimit',
        message: CampaignErrorHandleField.perHeadLimit.message?.replace(
          '%{totalNumberOfGeneratedCoupons}',
          `${linkedCoupon?.totalNumberOfGeneratedCoupons}`,
        ),
      });
    }
    // errorFields.push(CampaignErrorHandleField.requiredPoints.name);
  }

  if (campaignType === CampaignType.ticketCampaign) {
    let couponSetPkIndexMap = {};
    ticketCampaignTimeSlots?.length > 0 &&
      ticketCampaignTimeSlots.forEach((item, index) => {
        const { couponSet, translations } = item;
        const enTimeSlot = translations?.[LanguageConfig.english]?.timeSlot;
        if (!couponSet?.pk) {
          errorList.push({
            name: `ticketCampaignTimeSlots.${index}.couponSet`,
            message: 'Please select a coupon set.',
          });
        } else {
          couponSetPkIndexMap[couponSet.pk] = [
            ...(couponSetPkIndexMap?.[couponSet.pk] || []),
            index,
          ];
        }
        if (!enTimeSlot) {
          errorList.push({
            name: `ticketCampaignTimeSlots.${index}.translations.${LanguageConfig.english}.timeSlot`,
            message: 'Please input time slot.',
          });
        }
      });

    const couponsSetPks = Object.keys(couponSetPkIndexMap) || [];
    let duplicateCouponSetIndex = [];

    couponsSetPks?.length > 0 &&
      couponsSetPks.forEach((couponSetPk) => {
        if (couponSetPkIndexMap?.[couponSetPk]?.length <= 1) {
          return;
        }
        duplicateCouponSetIndex = duplicateCouponSetIndex.concat(
          couponSetPkIndexMap?.[couponSetPk],
        );
      });
    duplicateCouponSetIndex?.length > 0 &&
      duplicateCouponSetIndex.forEach((couponSetIndex) => {
        errorList.push({
          name: `ticketCampaignTimeSlots.${couponSetIndex}.couponSet`,
          message: 'Duplicated coupon set.',
        });
      });

    const questionFieldNames = [];
    showCustomerProfileFields?.length > 0 &&
      showCustomerProfileFields.forEach(item => {
        questionFieldNames.push(item.fieldName);
      });

    showCustomerAdditionalFields?.length > 0 &&
      showCustomerAdditionalFields.forEach(item => {
        questionFieldNames.push(item.fieldName)
      })

    additionalQuestion?.length > 0 &&
      additionalQuestion.forEach((item, index) => {
        const fieldName = item?.translations?.[LanguageConfig.english]?.fieldName;
        if (questionFieldNames.includes(fieldName)) {
          errorList.push({
            name: `ticketCampaignAdditionalQuestion.${index}.fieldName`,
            message: 'Duplicated field name, please change to another',
          })
        }
        questionFieldNames.push(fieldName);
      });
  }
  if (!isAlwaysVisiblePeriod) {
    if (visibleStartDate.getTime() >= visibleEndDate.getTime()) {
      errorList.push({
        name: 'visibleEndDate',
        message: isStampCampaign
          ? StampCampaignErrorHandleField.visibleEndDate.message
          : CampaignErrorHandleField.visibleEndDate.message,
      });
    } else {
      if (
        !!relatedBannerStartDate &&
        new Date(relatedBannerStartDate) < new Date(visibleStartDate)
      ) {
        errorList.push({
          name: 'visibleStartDate',
          message:
            'The visible period must be equal or longer than the linked campaign’s visible period, please try again.\n' +
            `The linked banner start date: ${formatDate(
              relatedBannerStartDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
      }
      if (
        !!relatedBannerEndDate &&
        new Date(visibleEndDate) < new Date(relatedBannerEndDate)
      ) {
        errorList.push({
          name: 'visibleEndDate',
          message:
            'The visible period must be equal or longer than the linked campaign’s visible period, please try again.\n' +
            `The linked banner end date: ${formatDate(
              relatedBannerEndDate,
              TimeFormater.dayMonthYearWeekTimePeriod,
            )}`,
        });
      }
    }
  }
  console.log('@@45-486: ', ProcessEnvConfig.haveShopMall, malls?.length)
  if (ProcessEnvConfig.haveShopMall && (!malls || malls?.length <= 0)) {
    errorList.push({
      name: 'malls',
      message: 'Please select a mall',
    });
  }
  if (isExclusive) {
    if (
      (generalType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT && !dynamicSegments?.length)
      || (generalType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT && !staticSegments?.length)
    ) {
      errorList.push(
        isStampCampaign ? {
          name: StampCampaignErrorHandleField.segment.name,
          message: StampCampaignErrorHandleField.segment.message,
        } : {
          name: CampaignErrorHandleField.segment.name,
          message: CampaignErrorHandleField.segment.message,
        });
    }
    else if (generalType === TARGET_CUSTOMER_TYPE.LEVEL && !levels?.length) {
      errorList.push(
        isStampCampaign ? {
          name: StampCampaignErrorHandleField.levels.name,
          message: StampCampaignErrorHandleField.levels.message,
        } : {
          name: CampaignErrorHandleField.levels.name,
          message: CampaignErrorHandleField.levels.message,
        });
    }
  }
  if (excludeBlacklistSegment && !blacklistSegments?.length) {
    errorList.push({
      name: CampaignErrorHandleField.blacklistSegments.name,
      message: CampaignErrorHandleField.blacklistSegments.message,
    });
  }
  recurringDateValidate({ getValues, errorList })

  recurringMessageValidate({ getValues, errorList });

  console.log("@@errorList", errorList);

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

const fourStepValidate = ({ getValues, setError, checkCheckList }) => {
  const [checkList, campaignType] = getValues(['checkList', 'campaignType']);
  if (Object.keys(checkList || {}).length === 0 || !checkCheckList) {
    return true;
  }
  const errorList = [];
  (Object.entries(checkList) || []).forEach(([key, value]) => {
    if (!value) {
      errorList.push({
        name: 'checkList',
        message:
          campaignType === CampaignType.stampCampaign
            ? StampCampaignErrorHandleField.checkList.message
            : CampaignErrorHandleField.checkList.message,
      });
      return;
    }
  });
  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
};

export function validate({
  getValues,
  setError,
  clearErrors,
  step,
  isBack,
  checkCheckList = false,
  languages = [LanguageConfig.english],
}) {
  console.log('@71 campaignValidate:', getValues());
  if (isBack) {
    return true;
  }
  clearErrors();
  const campaignType = getValues('campaignType');
  switch (campaignType === CampaignType.stampCampaign ? step + 1 : step) {
    case 0:
      const validStepOne = firstStepValidate({ getValues, setError });
      return validStepOne;
    case 1:
      const validStepTwo = secondStepValidate({
        getValues,
        setError,
        languages,
      });
      return validStepTwo;
    case 2:
      const validStepThree = thirdStepValidate({ getValues, setError });
      return validStepThree;
    case 3:
      const validStepFour = fourStepValidate({
        getValues,
        setError,
        checkCheckList,
      });
      return validStepFour;
    default:
      const validOne = firstStepValidate({ getValues, setError });
      const validTwo = secondStepValidate({ getValues, setError });
      const validThree = thirdStepValidate({ getValues, setError });
      const validFour = fourStepValidate({
        getValues,
        setError,
        checkCheckList,
      });
      return validOne && validTwo && validThree && validFour;
  }
}